module.exports = __webpack_public_path__ + "img/微信预览背景.a2cb43bb.png";